export default "__VITE_ASSET__DqI27qXd__"